<!-- <div fxLayout="row" fxLayoutAlign="space-around center"> -->
<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner *ngIf="cargandoDatos" diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos">&nbsp; Cargando datos...</label>
  </div>
</div>

<app-header sub_titulo="Validaciones"></app-header>
<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: 99%">
  <div style="min-height: 100vh; height: auto">
    <div class="card-body-content" style="
          width: 99%;
          min-height: 99%;
          max-height: 99%;
          padding-bottom: 10px;
          height: auto;
        ">
      <br />
      <mat-card style="height: 99%">
        <!-- 
          <div class="filter">
            <app-generic-select [options]="myOptions" placeholder="Filtro" (selectionChange)="onSelected($event)">
            </app-generic-select>
          </div> -->
        <div class="card-body-content" style="display: flex; height: auto">
          <div style="background-color: #f8f8ff; width: 100%; height: auto">
            <mat-card appearance="outlined" class="card-principal">
              <div style="width: 100%" class="container">
                <div id="flex-start">
                  <button mat-raised-button color="primary" (click)="nuevaValidacion()" style="
                        background-color: #108f5a;
                        padding-bottom: 10px;
                        padding-top: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                      ">
                    Agregar nueva validación
                    <mat-icon>library_add</mat-icon>
                  </button>
                  <button mat-raised-button *ngIf="validacionSeleccionada" [disabled]="!habilitarBotones"
                    (click)="editarValidacion()" [ngStyle]="
                        habilitarBotones
                          ? { 'background-color': '#3f51b5' }
                          : {
                              'background-color': 'rgba(0,0,0,.12)',
                              color: '#3a3737',
                              'font-size': '14px'
                            }
                      " color="primary" class="botonModificar" style="
                        background-color: #3f51b5;
                        padding-bottom: 10px;
                        padding-top: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                      ">
                    Modificar
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                  <button *ngIf="validacionSeleccionada && puedeCrearOEliminar" mat-raised-button
                    [disabled]="!habilitarBotonEliminar" [ngStyle]="
                        habilitarBotonEliminar
                          ? { 'background-color': '#f44336' }
                          : {
                              'background-color': 'rgba(0,0,0,.12)',
                              color: '#3a3737',
                              'font-size': '14px'
                            }
                      " color="warn" (click)="seleccionarParaEliminar()" style="
                        padding-bottom: 10px;
                        padding-top: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                      ">
                    Eliminar
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button
                    mat-raised-button
                    style="
                    background-color: #3f51b5;
                    padding-bottom: 10px;
                    padding-top: 10px;
                    margin-right: 10px;
                    margin-top: 10px;
                  "
                    color="primary"
                    (click)="cargarArchivo()"
                    class="botonMenu"
                  >
                    Importar Destinatarios/Validaciones
                    <mat-icon>file_upload</mat-icon>
                  </button>
                </div>
                <div id="flex-end">
                  <mat-form-field class="form-filter-area" appearance="fill">
                    <mat-label>Filtrar por tipo</mat-label>
                    <mat-select (selectionChange)="aplicarFiltro()" [(ngModel)]="tipoFiltrado" name="area">
                      <mat-option value="">Todos</mat-option>
                      <mat-option *ngFor="let tipoValidacion of tiposValidaciones" [value]="tipoValidacion">
                        <span>{{tipoValidacion.nombre}}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="form-filter-codigo" appearance="fill">
                      <mat-label>Filtrar por código</mat-label>
                      <input matInput (keyup)="aplicarFiltro()" [(ngModel)]="filtroCodigo">
                  </mat-form-field>
                  <mat-form-field class="form-filter-nombre" appearance="fill">
                      <mat-label>Filtrar por nombre</mat-label>
                      <input matInput (keyup)="aplicarFiltro()" [(ngModel)]="filtroNombre">
                  </mat-form-field>
                </div>
              </div>
              <div class="contenedor_tabla">
                <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                  <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef class="column-width-50">
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="column-width-50" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      <mat-radio-button class="radio-class" (change)="seleccionarValidacion(element)">
                      </mat-radio-button>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="codigo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla column-width-100">
                      Código
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="textoCentradoTabla column-width-100" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      {{ element.codigo }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="nombre">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla column-width-200">
                      Nombre
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="textoCentradoTabla column-width-200" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      {{ element.nombre }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="tipo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla column-width-100">
                      Tipo
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="textoCentradoTabla column-width-100" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      {{ element.tipo.nombre}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="fechaActualizacion">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla column-width-170">
                      Fecha Actualización
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="textoCentradoTabla column-width-170" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      {{ element.fechaActualizacion }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="usuarioActualizador">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla column-width-100">
                      Usuario Actualización
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="textoCentradoTabla column-width-100" [ngStyle]="
                          element.habilitado
                            ? { 'background-color': 'rgb(240 243 243)' }
                            : { 'background-color': 'rgba(0,0,0,.12)' }
                        ">
                      {{ element.usuarioActualizador }}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <mat-paginator [length]="100" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>
                <button mat-raised-button  (click)="volver()">Cancelar</button>
              </div>
            </mat-card>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</mat-card>
<!-- </div> -->